import React from 'react';

import styles from './MyPagePanel.module.scss';

interface Props {
  title?: string;
  children?: React.ReactNode;
  hidePanelTitleIfMobile?: boolean;
}

const MyPagePanel: React.FC<Props> = ({
  title,
  children,
  hidePanelTitleIfMobile,
}) => (
  <div className={styles.wrapper}>
    {title && (
      <div
        className={`${styles.panelHeader} ${hidePanelTitleIfMobile ? styles.hideTitleOnMobile : ''}`}
      >
        <div>
          <h2>{title}</h2>
        </div>
      </div>
    )}
    <div className={styles.panelBody}>{children}</div>
  </div>
);

export default MyPagePanel;
